"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NamedSettingsItem = exports.NamedSettingsItemWithoutRef = void 0;
const react_1 = __importStar(require("react"));
const MenuItem_1 = __importDefault(require("@material-ui/core/MenuItem"));
const ListItemIcon_1 = __importDefault(require("@material-ui/core/ListItemIcon"));
const ArrowRight_1 = __importDefault(require("@material-ui/icons/ArrowRight"));
function NamedSettingsItemWithoutRef({ label, onClick, closeMenu, selected }, ref) {
    return (react_1.default.createElement(MenuItem_1.default, { ref: ref, onClick: () => {
            onClick();
            closeMenu();
        } },
        react_1.default.createElement(ListItemIcon_1.default, null, selected && react_1.default.createElement(ArrowRight_1.default, { fontSize: "small" })),
        react_1.default.createElement(react_1.default.Fragment, null, label)));
}
exports.NamedSettingsItemWithoutRef = NamedSettingsItemWithoutRef;
exports.NamedSettingsItem = react_1.forwardRef(NamedSettingsItemWithoutRef);
//# sourceMappingURL=named-settings-item.js.map